module.exports = new __parcel__URL__("thunderfire.ea49eab9.png").toString();